import { Skeleton } from "antd";

export default function TableSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <div className="w-full space-y-3">
      {Array.from(Array(rows).keys())?.map((item) => (
        <Skeleton
          key={item}
          active={true}
          paragraph={{ rows: 1, width: "100%" }}
          title={false}
          className="[&_.ant-skeleton-paragraph]:mb-0"
        />
      ))}
    </div>
  );
}
